import { parametersActions } from './actions';
import { parametersMutations } from './mutations';
import { parametersGetters } from './getters';

const today = new Date()

const state = {
    dates: {
        start: new Date(today.getFullYear(), today.getMonth(), 2)
            .toISOString()
            .substr(0, 10),
        end: today.toISOString().substr(0, 10),
    },

    main_calendar_refresh: false,
    
    audit_dates: {
        start: null,
        end: null
    },

    expert_dates: {
      start: null,
      end: null
    },

    expert_calendar_refresh: false,

    niv2_dates: {
      start: null,
      end: null
    },

    niv2_calendar_refresh: false,

    parc_dates:{
        start: null
      
    },

    parc_calendar_refresh: false,   

    expert_pdm: null,

    geo_pdm: null,
    timestep: 'weekly',

    installations_groups: ['audit', 'reporting', 'informations', 'configuration'],
    
    show_date_selector: false,
};

const actions = { ...parametersActions };
const mutations = { ...parametersMutations };
const getters = { ...parametersGetters };

// eslint-disable-next-line import/prefer-default-export
export const parametersStore = {
    state, actions, mutations, getters,
};
